var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationbell01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.80924C2 5.00332 2.84285 3.27136 4.34315 1.99438C5.84344 0.7174 7.87827 0 10 0C12.1217 0 14.1566 0.7174 15.6569 1.99438C17.1571 3.27136 18 5.00332 18 6.80924V10.8071L20 13.3606V17.0231H14.389C14.1615 17.8689 13.6036 18.624 12.8064 19.1647C12.0091 19.7055 11.0199 20 10.0005 20C8.98109 20 7.99185 19.7055 7.19465 19.1647C6.39744 18.624 5.83946 17.8689 5.612 17.0231H0V13.3606L2 10.8071V6.80924ZM7.708 17.0231C7.90238 17.4029 8.2228 17.7262 8.62995 17.9532C9.03709 18.1803 9.51325 18.3012 10 18.3012C10.4867 18.3012 10.9629 18.1803 11.3701 17.9532C11.7772 17.7262 12.0976 17.4029 12.292 17.0231H7.708ZM10 1.70231C8.4087 1.70231 6.88258 2.24036 5.75736 3.1981C4.63214 4.15583 4 5.4548 4 6.80924V11.3229L2 13.8764V15.3208H18V13.8764L16 11.3229V6.80924C16 5.4548 15.3679 4.15583 14.2426 3.1981C13.1174 2.24036 11.5913 1.70231 10 1.70231Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationbell01);
export default __webpack_public_path__ + "static/media/NOTIFICATION BELL01.2b073eed647560cac8041499e387c01a.svg";
export { ForwardRef as ReactComponent };